<template>
  <div>
    <el-tooltip content="Model History">
      <el-button type="text" @click="openModal = true">
        <svgicon name="Report-chart2" class="history-icon" />
      </el-button>
    </el-tooltip>
    <el-dialog
      :visible.sync="openModal"
      title="Model History"
      width="700px">
      <el-table
        :data="historyList"
        size="mini">
        <el-table-column
          label="Model name"
          prop="model_name" />
        <el-table-column
          label="Date"
          prop="created_at"
          width="170"
          :formatter="formatterDate" />
        <el-table-column
          label="Score, %"
          prop="model_map"
          width="150">
          <template slot-scope="scope">
            <div class="mAP">
              <el-tooltip
                :content="scope.row.isError ? 'This is a bad training result because score < 70%' : 'This is a good training result because score > 70%'"
                :popper-class="scope.row.isError ? 'is-red' : 'is-green'">
                <svgicon :name="scope.row.isError ? 'Error' : 'Success'" width="16px" />
              </el-tooltip>
              <span>{{ scope.row.model_map }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Actions"
          prop="actions"
          width="68">
          <template slot="header">
            <el-tooltip>
              <div slot="content">
                <b>Score Parameters:</b>
                <div>more 70% — Success Training</div>
                <div>less 70% — Bad Result</div>
              </div>
              <svgicon name="Info" width="16px" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-tooltip content="Edit">
              <el-button type="text" @click="handleEdit(scope.row)">
                <svgicon name="Edit2" width="16px" color="var(--primary)" />
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-button @click="openModal = false">Cancel</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getModelsHistory } from '@/api/models';

export default {
  name: "ModelsHistory",
  data() {
    return {
      historyList: [],
      openModal: false,
    }
  },
  watch: {
    openModal(value) {
      if (value) {
        this.getHistory();
      }
    },
  },
  methods: {
    ...mapActions({
      error: 'error',
    }),
    formatterDate({ created_at }) {
      return new Date(created_at).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });
    },
    async getHistory() {
      const { data = {} } = await getModelsHistory();
      this.historyList = data.models.map(el => ({
        ...el,
        isError: el.model_map < 70,
      }));
    },
    handleEdit({ project_id: projectId, project_type: type, video_id: videoId }) {
      if (!projectId || !videoId) {
        this.error('This model does not have project ID or video ID');
        return;
      }

      this.$router.push({ name: 'frame-view', params: { projectId, videoId, type }});
    },
  },
}
</script>

<style scoped lang="scss">
.mAP {
  display: flex;
  gap: 12px;
}

.history-icon {
  min-width: 32px;
  height: 32px;
  padding: 8px;
  color: var(--primary);
  border: 1px solid var(--border-color);
  border-radius: 3px;
  opacity: 0.7;
}

/deep/ {
  .el-dialog .el-dialog__body {
    padding: 0;
  }

  .el-table {
    td, th {
      background: var(--grey);
      color: var(--primary);
    }

    th {
      padding: 12px 0;
      font-weight: 700;
      font-size: 16px;
    }

    th:not(:last-child) {
      opacity: 0.7;
    }

    td {
      font-size: 14px;
    }

    td:first-child,
    th:first-child {
      padding-left: 30px;
    }

    td:first-child {
      font-weight: 700;
    }

    th:last-child,
    td:last-child {
      svg {
        opacity: 0.5;
      }
    }
  }
}
</style>
